/**
 * Software download configuration
 */
export const SOFTWARE_DOWNLOAD_URL = 'https://time-sentinel.com/download/TimeSentinel-Latest-Setup.exe';
